import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kndfsdgcuyjqzdptmtbe.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtuZGZzZGdjdXlqcXpkcHRtdGJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc2NTY5NDgsImV4cCI6MjA2MzIzMjk0OH0.5W8Msz9OUMYvC6pmfm8P6xSK0r-I-DxlbOEg17nY5kY';
export const supabase = createClient(supabaseUrl, supabaseKey);

export const fetchNodeById = async (id) => {
    const { data, error } = await supabase
        .from('quiz_nodes')
        .select('*')
        .eq('id', id); //

    if (error) throw error;
    if (!data || data.length === 0) {
        throw new Error(`No node found for id: ${id}`);
    }

    return data[0]; //
};

export const fetchAnswersForNode = async (from_node_id) => {
    const { data, error } = await supabase
        .from('answer_edges')
        .select('*')
        .eq('from_node_id', from_node_id);
    if (error) throw error;
    return data;
};